import { Component, OnInit } from "@angular/core";
import { SelectItem } from "primeng/api";
import { DataService } from "../../../data.service";
import { DateUtils } from "../../../shared/date-utils";


@Component({
    selector: 'app-daily',
    templateUrl: './daily.component.html',
    styleUrls: ['./daily.component.css'],
    standalone: false
})
export class DailyStatisticComponent implements OnInit {
    period = new Date();
    dailyStatistic: any;
    selectedType: number = 1;
    chartMode: boolean = false;
    dataLoading: boolean = false;
    statTypes: SelectItem[] = [
        { label: 'Добавлено', value: 1 },
        { label: 'На складе', value: 2 },
        { label: 'Отправлено', value: 4 },
        { label: 'Прибыло', value: 5 },
        { label: 'Вручено', value: 6 }
    ];

    constructor(private dataService: DataService) {
    }

    ngOnInit() {
        this.showData();
    }

    showData() {
        this.dataLoading = true;
        const subscr = this.dataService.dailyStatistic(DateUtils.unixTimestamp(this.period), this.selectedType).subscribe({
            next: (result) => {
                if (Array.isArray(result)) {
                    if (result.length === 0) {
                        this.dailyStatistic = null;
                    } else {
                        this.dailyStatistic = result;
                    }
                }
            },
            error: (err) => {
                this.dataLoading = false;
                this.dailyStatistic = null;
            },
            complete: () => {
                subscr.unsubscribe();
                this.dataLoading = false;
            }
        })
    }

    changeType() {
        this.dailyStatistic = null;

        if (this.period) {
            this.showData();
        }
    }
}
